export const FACTION_CREATION_ALLOWED_EMAILS = [
  'luca.biddeci@gmail.com',
  'mbho.alc@gmail.com',
  'lukebidde@gmail.com',
  'fantafwi@gmail.com'
];

export const FACTION_CREATION_UNLOCK_AT = new Date('2026-05-01T12:00:00+02:00');

export const normalizeEmail = (email) => (email || '').trim().toLowerCase();

export const isFactionCreationAllowedEmail = (email) => (
  FACTION_CREATION_ALLOWED_EMAILS.includes(normalizeEmail(email))
);

export const isFactionCreationSeasonOpen = (now = new Date()) => (
  now.getTime() >= FACTION_CREATION_UNLOCK_AT.getTime()
);

export const canCreateFaction = (email, now = new Date()) => (
  isFactionCreationAllowedEmail(email) || isFactionCreationSeasonOpen(now)
);

export const getFactionCreationRemaining = (now = new Date()) => {
  const remainingMs = Math.max(FACTION_CREATION_UNLOCK_AT.getTime() - now.getTime(), 0);

  return {
    totalMs: remainingMs,
    days: Math.floor(remainingMs / (1000 * 60 * 60 * 24)),
    hours: Math.floor((remainingMs / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((remainingMs / (1000 * 60)) % 60),
    seconds: Math.floor((remainingMs / 1000) % 60),
  };
};
